import * as configDev from './config.dev'
import * as configOnline from './config.online'

const { VUE_APP_CONFIG } = process.env
const config = VUE_APP_CONFIG === 'online' ? configOnline : configDev
export default config
